(function (app, ng) {
    var clientDateStructure = {
        ClientStartDate: "date",
        Person: {
            Dob: "date"
        }
    };

    function datify(obj, structure) {
        if (!obj) return;
        if (ng.isArray(structure)) {
            for (var i = 0; i < obj.length; i++) {
                if (structure[0] === "date" && ng.isString(obj[i]))
                    obj[i] = new Date(obj[i]);
                if (ng.isObject(structure[0]) || ng.isArray(structure[0]))
                    datify(obj[i], structure[0]);
            }
            return;
        }
        if (ng.isObject(structure)) {
            for (var key in structure) {
                if (!structure.hasOwnProperty(key)) continue;
                if (structure[key] === "date" && ng.isString(obj[key]))
                    obj[key] = new Date(obj[key]);
                if (ng.isObject(structure[key]) || ng.isArray(structure[key]))
                    datify(obj[key], structure[key]);
            }
        }
    }

    app.provider("clientApi", [
        function () {
            this.$get = ["crmApiGateway", function (crmApiGateway) {
                var service = {};

                // GETs
                service.get = function (clientId) {
                    return crmApiGateway.get("/Clients/" + clientId).then(function (client) {
                        datify(client, clientDateStructure);
                        return client;
                    });
                };

                service.getCurrentUserClients = function (nextPageToken) {
                    var url = "/Users/Me/Clients";

                    if (nextPageToken)
                        url += "?nextPageToken=" + nextPageToken;

                    return crmApiGateway.getArray(url);
                };

                service.getClientSummary = function (clientId) {
                    return crmApiGateway.get("/Clients/" + clientId + "/Summary");
                };

                service.searchClients = function (term) {
                    return crmApiGateway.getArray("/Clients/Search?q=" + term).then(function (results) {
                        datify(results, [clientDateStructure]);
                        return results;
                    });
                };

                service.getClientTypes = function () {
                    return crmApiGateway.getArray("/ClientTypes");
                };

                service.getReferrals = function (clientId) {
                    return crmApiGateway.getArray("/ClientReferrals/Client/" + clientId);
                };

                service.getPrimaryAdvisor = function (clientId) {
                    return crmApiGateway.get("/Clients/" + clientId + "/PrimaryAdvisor");
                };

                service.getTags = function (clientId) {
                    return crmApiGateway.getArray("/Clients/" + clientId + "/Tags");
                };

                service.getTimeline = function (clientId, nextPageToken) {
                    var url = "/Clients/" + clientId + "/Timeline";
                    if (nextPageToken)
                        url += "?nextPageToken=" + nextPageToken;
                    return crmApiGateway.getArray(url).then(function (tasks) {
                        ng.forEach(tasks,
                            function (row) {
                                datify(row, clientDateStructure);
                            });
                        return tasks;
                    });
                };

                //PUTs
                service.update = function (client) {
                    return crmApiGateway.put("/Clients/" + client.Id, client);
                };

                service.updateClientPrimaryAdvisor = function (clientId, advisor) {
                    return crmApiGateway.put("/Clients/" + clientId + "/PrimaryAdvisor", advisor);
                };

                service.addClientTag = function (clientId, tag) {
                    return crmApiGateway.put("/Clients/" + clientId + "/Tags/" + tag.Id, tag);
                };

                service.updateClientNote = function (clientId, note) {
                    return crmApiGateway.put("/Clients/" + clientId + "/Notes/" + note.Id, note);
                };

                //POSTs
                service.addClientReferral = function (clientReferral) {
                    return crmApiGateway.post("/ClientReferrals", clientReferral);
                };

                service.add = function (client) {
                    return crmApiGateway.post("/Clients", client);
                };

                service.addClientNote = function (clientId, note) {
                    return crmApiGateway.post("/Clients/" + clientId + "/Notes", note);
                };
                
                service.importContacts = (formdata) => {
                    return crmApiGateway.postFile("/Imports/Clients/Upload", formdata);
                };

                //DELETEs
                service.removeClientTag = function (clientId, tagId) {
                    return crmApiGateway.delete("/Clients/" + clientId + "/Tags/" + tagId);
                };

                service.removeClientPrimaryAdvisor = function (clientId) {
                    return crmApiGateway.delete("/Clients/" + clientId + "/PrimaryAdvisor");
                };

                service.removeClientReferral = function (clientReferralId) {
                    return crmApiGateway.delete("/ClientReferrals/" + clientReferralId );
                };

                service.removeClientNote = function (clientId, noteId) {
                    return crmApiGateway.delete("/Clients/" + clientId + "/Notes/" + noteId);
                };

                return service;
            }];
        }
    ]);

})(window.app, window.angular); // jshint ignore:line